(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["delivery-checker"] && !Shopify.designMode) return;
  try {
    (function () {

  'use strict';


  /* =======================================================
     PINCODE HELPERS
  ======================================================= */

  function sanitizePincode(value) {

    return String(value || '')
      .replace(/\D/g, '')
      .slice(0, 6);

  }


  /*
    Basic Indian PIN format validation:

    - exactly 6 digits
    - first digit cannot be 0
  */

  function isValidIndianPincode(pincode) {

    return /^[1-9][0-9]{5}$/.test(pincode);

  }


  /* =======================================================
     INDIA DATE
  ======================================================= */

  function getIndiaDateParts() {

    var formatter = new Intl.DateTimeFormat(
      'en-CA',
      {
        timeZone: 'Asia/Kolkata',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
    );


    var parts = formatter.formatToParts(
      new Date()
    );


    var values = {};


    parts.forEach(function (part) {

      if (part.type !== 'literal') {

        values[part.type] = part.value;

      }

    });


    return {
      year: Number(values.year),
      month: Number(values.month),
      day: Number(values.day)
    };

  }


  /* =======================================================
     DELIVERY DATE
  ======================================================= */

  function getEstimatedDeliveryDate(daysToAdd) {

    var indiaToday = getIndiaDateParts();


    /*
      UTC noon avoids timezone/date rollover
      edge cases during date arithmetic.
    */

    var deliveryDate = new Date(
      Date.UTC(
        indiaToday.year,
        indiaToday.month - 1,
        indiaToday.day + daysToAdd,
        12,
        0,
        0
      )
    );


    var deliveryYear =
      deliveryDate.getUTCFullYear();


    var options = {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      timeZone: 'UTC'
    };


    /*
      Show the year only if the estimate
      crosses into a different year.
    */

    if (deliveryYear !== indiaToday.year) {

      options.year = 'numeric';

    }


    return new Intl.DateTimeFormat(
      'en-IN',
      options
    ).format(deliveryDate);

  }


  /* =======================================================
     ESCAPE HTML
  ======================================================= */

  function escapeHtml(value) {

    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');

  }


  /* =======================================================
     SUCCESS RESULT

     Intentionally kept to ONE line for CRO
     and minimum vertical space.
  ======================================================= */

  function showSuccess(checker, result) {

    var deliveryDays = parseInt(
      checker.getAttribute(
        'data-delivery-days'
      ),
      10
    );


    if (
      !Number.isFinite(deliveryDays) ||
      deliveryDays < 0
    ) {

      deliveryDays = 4;

    }


    var deliveryDate =
      getEstimatedDeliveryDate(
        deliveryDays
      );


    var prefix =
      result.getAttribute(
        'data-success-prefix'
      ) ||
      'Express delivery by';


    result.innerHTML =
      '<div class="kyoot-pincode-checker__result-card kyoot-pincode-checker__result-card--success">' +

        '<span class="kyoot-pincode-checker__result-icon" aria-hidden="true">' +

          '<svg viewBox="0 0 20 20" width="13" height="13" fill="none" xmlns="http://www.w3.org/2000/svg">' +

            '<path d="M4.5 10.2L8.1 13.6L15.7 6.2" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"></path>' +

          '</svg>' +

        '</span>' +

        '<div class="kyoot-pincode-checker__result-content">' +

          '<span class="kyoot-pincode-checker__result-title">' +

            escapeHtml(prefix) +

            ' <span class="kyoot-pincode-checker__date">' +

              escapeHtml(deliveryDate) +

            '</span>' +

          '</span>' +

        '</div>' +

      '</div>';


    result.hidden = false;

  }


  /* =======================================================
     INVALID PIN RESULT
  ======================================================= */

  function showInvalid(result) {

    var invalidMessage =
      result.getAttribute(
        'data-invalid-message'
      ) ||
      'Invalid PIN code';


    result.innerHTML =
      '<div class="kyoot-pincode-checker__result-card kyoot-pincode-checker__result-card--invalid">' +

        '<span class="kyoot-pincode-checker__result-icon" aria-hidden="true">' +

          '<svg viewBox="0 0 20 20" width="11" height="11" fill="none" xmlns="http://www.w3.org/2000/svg">' +

            '<path d="M5.5 5.5L14.5 14.5M14.5 5.5L5.5 14.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"></path>' +

          '</svg>' +

        '</span>' +

        '<div class="kyoot-pincode-checker__result-content">' +

          '<span class="kyoot-pincode-checker__result-title">' +

            escapeHtml(invalidMessage) +

          '</span>' +

          '<div class="kyoot-pincode-checker__invalid-help">' +

            'Enter a valid 6-digit Indian PIN code.' +

          '</div>' +

        '</div>' +

      '</div>';


    result.hidden = false;

  }


  /* =======================================================
     INPUT HANDLING
  ======================================================= */

  document.addEventListener(
    'input',
    function (event) {

      var input = event.target.closest(
        '[data-kyoot-pincode-input]'
      );


      if (!input) {

        return;

      }


      var cleanValue =
        sanitizePincode(
          input.value
        );


      if (input.value !== cleanValue) {

        input.value = cleanValue;

      }


      var checker = input.closest(
        '[data-kyoot-pincode-checker]'
      );


      if (!checker) {

        return;

      }


      var result = checker.querySelector(
        '[data-kyoot-pincode-result]'
      );


      /*
        Clear the previous status when the
        customer edits the PIN.
      */

      if (
        result &&
        !result.hidden
      ) {

        result.hidden = true;

        result.innerHTML = '';

      }

    }
  );


  /* =======================================================
     SUBMIT
  ======================================================= */

  document.addEventListener(
    'submit',
    function (event) {

      var form = event.target.closest(
        '[data-kyoot-pincode-form]'
      );


      if (!form) {

        return;

      }


      event.preventDefault();


      var checker = form.closest(
        '[data-kyoot-pincode-checker]'
      );


      if (!checker) {

        return;

      }


      var input = checker.querySelector(
        '[data-kyoot-pincode-input]'
      );


      var result = checker.querySelector(
        '[data-kyoot-pincode-result]'
      );


      if (!input || !result) {

        return;

      }


      var pincode =
        sanitizePincode(
          input.value
        );


      input.value = pincode;


      if (
        !isValidIndianPincode(
          pincode
        )
      ) {

        showInvalid(result);


        input.setAttribute(
          'aria-invalid',
          'true'
        );


        return;

      }


      input.removeAttribute(
        'aria-invalid'
      );


      showSuccess(
        checker,
        result
      );

    }
  );

})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-price"] && !Shopify.designMode) return;
  try {
    /* ==========================================================
   PDP PRICE — VARIANT UPDATES
   ========================================================== */

(() => {

  const priceBlocks = document.querySelectorAll('.pdp-price');

  if (!priceBlocks.length) return;


  /*
    Format a Shopify price.

    Horizon / Shopify normally exposes Shopify.formatMoney().
    We use it when available and fall back to a simple
    currency formatter if necessary.
  */

  function formatPrice(cents) {

    cents = Number(cents);

    if (!Number.isFinite(cents)) {
      return '';
    }


    if (
      typeof Shopify !== 'undefined' &&
      typeof Shopify.formatMoney === 'function'
    ) {

      /*
        Try Shopify's currently configured money format.
      */

      const moneyFormat =
        window.Shopify &&
        Shopify.money_format
          ? Shopify.money_format
          : '{{amount}}';

      return Shopify.formatMoney(cents, moneyFormat);
    }


    /*
      Fallback formatter.
    */

    const currency =
      document.documentElement.dataset.currency ||
      'INR';


    try {

      return new Intl.NumberFormat(
        document.documentElement.lang || 'en-IN',
        {
          style: 'currency',
          currency: currency,
          maximumFractionDigits: 0
        }
      ).format(cents / 100);

    } catch (error) {

      return '₹' + (cents / 100).toLocaleString('en-IN');

    }

  }


  /*
    Update one PDP price block.
  */

  function updatePriceBlock(block, variant) {

    if (!variant) return;


    const sellingPrice =
      block.querySelector('[data-selling-price]');

    const mrpPrice =
      block.querySelector('[data-mrp-price]');

    const discount =
      block.querySelector('[data-discount]');

    const discountText =
      block.querySelector('.pdp-price__discount-text');


    if (!sellingPrice) return;


    const currentPrice =
      Number(variant.price);


    const compareAtPrice =
      Number(variant.compare_at_price || 0);


    /*
      Update selling price.
    */

    if (Number.isFinite(currentPrice)) {

      sellingPrice.textContent =
        formatPrice(currentPrice);

    }


    /*
      Update MRP.
    */

    if (
      mrpPrice &&
      compareAtPrice > currentPrice
    ) {

      mrpPrice.textContent =
        formatPrice(compareAtPrice);

      mrpPrice.hidden = false;

    } else if (mrpPrice) {

      mrpPrice.textContent = '';

      mrpPrice.hidden = true;

    }


    /*
      Calculate discount.
    */

    let discountPercentage = 0;


    if (
      compareAtPrice > currentPrice &&
      compareAtPrice > 0
    ) {

      discountPercentage =
        Math.round(
          (
            (compareAtPrice - currentPrice) /
            compareAtPrice
          ) * 100
        );

    }


    /*
      Update discount badge.
    */

    if (
      discount &&
      discountText
    ) {

      if (discountPercentage > 0) {

        discountText.textContent =
          discountPercentage + '% OFF';

        discount.hidden = false;

      } else {

        discountText.textContent = '';

        discount.hidden = true;

      }

    }

  }


  /*
    Horizon dispatches variant information through
    the variant:change event.

    This allows the custom price block to update without
    relying on Horizon's native price markup.
  */

  document.addEventListener(
    'variant:change',
    function(event) {

      const variant =
        event.detail &&
        event.detail.variant;


      if (!variant) return;


      priceBlocks.forEach(function(block) {

        updatePriceBlock(
          block,
          variant
        );

      });

    }
  );


  /*
    Additional fallback for standard Shopify
    variant selectors.

    This catches changes from:
    - variant selects
    - radio buttons
    - option selectors
  */

  document.addEventListener(
    'change',
    function(event) {

      const target =
        event.target;


      if (!target) return;


      const isVariantInput =
        target.matches(
          'select[name="id"], ' +
          'input[name="id"], ' +
          'input[name^="options"], ' +
          'select[name^="options"]'
        );


      if (!isVariantInput) return;


      /*
        Give Horizon a moment to resolve the
        selected variant before reading it.
      */

      setTimeout(function() {

        const productForm =
          target.closest(
            'product-form, form[action*="/cart/add"]'
          );


        if (!productForm) return;


        const variantIdInput =
          productForm.querySelector(
            'input[name="id"]'
          );


        if (!variantIdInput) return;


        const variantId =
          Number(variantIdInput.value);


        if (!variantId) return;


        /*
          Look for the currently selected variant
          in the product JSON if available.
        */

        const productJson =
          document.querySelector(
            'script[type="application/json"][data-product-json]'
          );


        if (
          !productJson
        ) return;


        try {

          const product =
            JSON.parse(
              productJson.textContent
            );


          const variant =
            product.variants &&
            product.variants.find(
              item =>
                Number(item.id) === variantId
            );


          if (!variant) return;


          priceBlocks.forEach(function(block) {

            updatePriceBlock(
              block,
              variant
            );

          });

        } catch (error) {

          /*
            Do nothing.

            The primary variant:change listener
            will handle Horizon themes.
          */

        }

      }, 50);

    }
  );

})();
  } catch(e) { console.error(e); }
})();

})();
